export enum DataGroup {
    UserData = 1,
    Contact,
    Bank
}
    